export default "__VITE_ASSET__CN8Y11mG__"